import './index.less'
import Panel from '../panel'

const createMarker = function(data , content , style){
  let marker = new AMap.Marker({
    position: new AMap.LngLat(data.longitude,data.latitude),
    content: `<div class="route-view-marker circle ${style}">${content}</div>`,
    offset: new AMap.Pixel(-10, -28),
    topWhenClick:true,
    extData: data,
    zIndex:3001
  });

  marker.focus = function(v){
    if(v === false){
      this.setContent( `<div class="route-view-marker circle">${content}</div>` )
    }else{
      this.setContent( `<div class="route-view-marker circle focus">${content}</div>` )
    }
  }

  return marker
}

export default {
  props:['data'],
  data(){
    return {
      map:null,
      pointId:null,
      focusOverlay:null,
    }
  },
  created(){
    this.$watch('data.route' , function(){
      this.renderRoute()
    },{immediate:true})
  },
  methods:{
    init(map){
      this.map = map
      this.overlayGroup = new AMap.OverlayGroup()
      this.overlayGroup.setMap( map )
      this.overlayGroup.on('click',this.overlayClick, this)
      this.renderRoute()
    },
    overlayClick(evt){
      this.setFocus(evt.target)
    },
    setFocus(target){
      let data = target.getExtData()
      if( data._trigger ){
        if( this.focusOverlay ){
          if( this.focusOverlay.getExtData().id == data.id ) return
          this.focusOverlay.focus(false)
        }

        this.pointId = data.id

        this.focusOverlay = target

        this.focusOverlay.focus()

        let zoom = this.map.getZoom()

        if( zoom < 16) zoom = 16
        this.map.setZoomAndCenter(zoom , target.getPosition())
      }
    },
    renderRoute(){
      if( this.map && this.data.route){
        if( this.route ) this.route.setMap( null )
        let path = this.data.route.map( i => ([i.lng,i.lat]) )
        let polyline = new AMap.Polyline({
          path,
          map: this.map,
          showDir: true,
          strokeColor: "#33b166",
          strokeOpacity: 0.65, //线透明度
          strokeWeight: 6, //线宽
          // strokeStyle: "solid"  //线样式,
          lineCap: 'round'
        })

        polyline.setMap( this.map )

        this.route = polyline
      }


      if( this.map && this.data.points ){
        this.overlayGroup.clearOverlays()
        this.focusOverlay = null
        for(let i = 0 ; i < this.data.points.length ; i++ ){
          let data = this.data.points[i] , l = this.data.points.length
          data._trigger = i > 0 && i < l - 1
          let overlay = createMarker(data , i == 0 ? '起' : (i == l - 1 ? '终' : i) , data._trigger ? 'red' : 'blue' )

          overlay.on('click' , this.overlayClick , this)
          this.overlayGroup.addOverlay( overlay )
        }
      }

      if(this.map) this.map.setFitView()
    },
    handleClosePanel(){
      if( this.focusOverlay ){
        this.focusOverlay.focus(false)
        this.pointId = null
        this.focusOverlay = null
      }
    }
  },
  render(){
    return <div class="route-view-detail">
      <sl-amap class="map" view-mode="2D" zoom={4} on-ready={this.init} />
      <Panel point-id={this.pointId} on-close={this.handleClosePanel} />
    </div>
  }
}